// uid: NPO-HOA-OCC_LDGR-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import CurrentOccupantLedgerRuleset from '../../business/ruleset/CurrentOccupantLedgerRuleset';
import { RulesetResult } from '../../business/rules';

const { currentOccupantLedger } = loanFormModel.formField.hoaDocuments;

export class CurrentOccupantLedgerValidation implements ValidationSchema {
  public name = currentOccupantLedger.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public ruleset = CurrentOccupantLedgerRuleset;

  public when(schema: any, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required)
      return FileNameValidationSchema(
        currentOccupantLedger.name,
        true
      ).required('This document is required');
    return FileNameValidationSchema(
      currentOccupantLedger.name,
      false
    ).notRequired();
  }
}
export default new Validation(new CurrentOccupantLedgerValidation());
